import { useState, useEffect, useMemo } from 'react';
import { paginateArray, scrollToListingsAnchor } from '../utils/properties';
import { LISTINGS_PAGE_SIZE } from '../config/constants';

const useListPagination = (items, resetKey, pageSize = LISTINGS_PAGE_SIZE) => {
  const [page, setPage] = useState(1);
  useEffect(() => {
    setPage(1);
  }, [resetKey]);
  const result = useMemo(() => paginateArray(items, page, pageSize), [items, page, pageSize]);
  const goToPage = (nextPage) => {
    const target = Math.min(Math.max(1, Number(nextPage) || 1), result.totalPages);
    setPage(target);
    requestAnimationFrame(() => scrollToListingsAnchor());
  };
  return { ...result, goToPage };
};

export default useListPagination;
